import React from 'react'
import Swal from 'sweetalert2'

import Wizard from '@modules/form-wizard'
import toastr from '@modules/toastr'
import { common, hull_types } from './duty-free'
import { BUSINESS_FIELDS } from '@modules/form-wizard/utils'
import generateRange from '@helpers/range'
import islands from '@constants/islands'
import ENV from '@constants/env'

const years = generateRange(1900, new Date().getFullYear())
  .map(v => ({
    value: v + '-01-01',
    label: v,
  }))
  .reverse()

export default class DutyFreeCommercialFishing extends React.Component {
  resource = '/duty_free_commercial_fishings'
  form_key = 'duty_free_commercial_fishing'
  free = true

  defaults = {}
  business_only = true
  skip_location = true

  hide_buttons = {
    approve: true,
    status: true,
  }

  metadata = {
    denied: { license_numb: '####' }
  }

  approve = async record => {
    this.setState({ loading: true })

    const { props, resource, form_key } = this
    const { history, location } = props
    const { axios } = $app

    try {
      await axios.put(resource + '/update_application', {
        [form_key]: {
          form_num: record.form_num,
          application_decision: 'approved',
          license_numb: record.license_numb,
        },
      })

      if (location.state?.view) {
        const view = { ...location.state.view }
        view.application_decision = 'approved'

        history.replace(location.pathname, { ...location.state, view })
      }

      toastr.success('Success', 'Application successfully approved')
    } catch (error) {
      console.error(error)
      toastr.error('Error', 'Unable to approve application')
      return
    }

    try {
      await axios.post('/emails', {
        email: record.user.email,
        subject: 'MyGateway Portal Update - New Compressor Permit',
        message: `
            Dear ${record.user.first_name.capitalize()},
            <br/>
            Congratulations! Your application for a new Compressor Permit has been approved.
            <br/>
            Your permit number is as follows: ${
              record.license_numb
            }. A downloadable PDF document will be sent to your email shortly.
            <br/>
            Thank you for using the MyGateway Portal.
          `,
      })

      toastr.success('Success', 'Confirmation email successfully sent')
      try {
        const { data } = await $app.axios.get('/services/all_paid_forms', {
          params: { service_type: this.service_type || props.service.type },
        })
        const updated_record = data.paid_forms.filter(
          d => d.id === record?.id
        )[0]
        await $app.axios.post('/emails', {
          email: record.user.email,
          subject: `MyGateqway Portal Update -  New Compressor Permit`,
          message: `
            Good day ${record.user.first_name.capitalize()},
            <br/>
           Your application for a Compressor Permit has been approved. As promised, below is a link to your downloadable PDF Permit.
            <br/><br />
            <p><b>Links</b></p>
            <ul>
            <li><a href='${`${ENV.WEB_SERVICE_URL}${updated_record?.image[0]}`}' target='_blank'>Compressor Permit</a></li>
            </ul>
            <br/><br/>
            Thank you for using MyGateway Portal.
          `,
        })
      } catch (error) {
        toastr.error('Error', 'Unable to send permit email')
        console.error(error)
      }
    } catch (err) {
      console.error(err)
      toastr.error('Error', 'Unable to send email')
    }

    this.setState({ loading: false })
  }

  before_apply = async () => {
    const { isConfirmed } = await Swal.fire({
      icon: 'warning',
      heading: 'Before You Apply',
      html: `
        <p class='text-base'>
          Before applying for this service, please ensure that
          you have the following documents as either a PDF or a clear image.
        </p>
        <ul class='text-left text-base'>
          <li>Vessel Bill of Sale</li>
          <li>Proof of Payment (i.e. bank drafts, etc.)</li>
          <li>Vessel's Certificate of Title</li>
          <li>Transfer Order</li>
          <li>Notice of Intended Registration in The Bahamas</li>
          <li>Passport</li>
          <li>Exchange Control's Permission to purchase foreign currency</li>
        </ul>
      `,
      confirmButtonText: 'I have the required documents',
      confirmButtonColor: '#0AAEEF',
      showCancelButton: true,
    })

    if (isConfirmed) return true

    Swal.fire(
      'Try Again Later',
      'Please collect the required documents, and then apply later',
      'info'
    )

    return null
  }

  fields = values => [
    ...BUSINESS_FIELDS(values),
    {
      name: 'phone',
      is: 'phone',
      use_profile: 'additional_phone_number',
    },
    {
      name: 'po_box',
      label: 'P. O. Box',
      required: false,
    },
    {
      name: 'nationality',
      use_profile: 'country_of_citizenship',
      disabled: true,
      view: {
        value: v => v?.initialCaps()
      }
    },
    {
      name: 'company_name',
      label: 'Name of Company',
    },
    '::Captain Detais',
    {
      name: 'captain',
      type: 'select:bool',
      label: 'Are you the intended captain?',
      view: {
        hide: !values.captain,
        label: 'Is Own Intended Captain',
        value: v => v ? 'Yes' : 'No',
      },
    },
    {
      name: 'captain_license_numb',
      label: 'Captain Licence #'
    },
    {
      name: 'captain_first_name',
      label: 'First Name',
      hide: values.captain !== false,
    },
    {
      name: 'captain_last_name',
      label: 'Last Name',
      hide: values.captain !== false,
    },
    {
      name: 'captain_license_upload',
      key: 'image.8',
      type: 'file:image',
      label: 'Copy of Captain Licence',
    },
    // {
    //   name: 'captain_nationality',
    //   label: 'Nationality',
    //   hide: values.captain !== false,
    //   options: countries,
    // },
    {
      heading: `
        <div>
          <h5 class='mb-0'>Vessel Details</h5>
          <span class='text-sm'>All length measurements should be in feet.</span>
        </div>
      `,
      view: {
        heading: 'Vessel Details'
      }
    },
    {
      name: 'vessel_builder',
      label: "Vessel Builder's Name",
    },
    {
      name: 'vessel_build_year',
      label: 'Year Built',
      options: years
    },
    {
      name: 'vessel_hull_type',
      label: 'Hull Type',
      options: hull_types,
    },
    {
      name: 'vessel_length',
      is: 'float',
      label: 'Overall Length',
      view: {
        value: v => v + ' ft.'
      }
    },
    {
      name: 'vessel_breadth',
      is: 'float',
      label: 'Breadth',
      required: false,
      hint: 'Omit if not available',
      view: {
        value: v => v + ' ft.'
      }
    },
    {
      name: 'vessel_draft',
      is: 'float',
      label: 'Draft',
      required: false,
      hint: 'Omit if not available',
      view: {
        value: v => v + ' ft.'
      }
    },
    {
      name: 'vessel_engine',
      label: 'Make of Engine(s)',
    },
    {
      name: 'vessel_hp',
      is: 'float',
      label: 'Total Horsepower of Engine(s)',
      view: {
        value: v => v + 'hp'
      }
    },
    {
      name: 'vessel_generators',
      label: 'Make of Generator(s)',
    },
    {
      name: 'vessel_hold',
      label: 'Type of Fish Hold',
      options: ['Cooler', 'Freezer', 'Ice Chest', 'Other'],
    },
    {
      name: 'vessel_capacity',
      is: 'float',
      label: 'Hold Capacity',
      hint: 'In pounds',
      view: {
        value: v => v + ' lbs.'
      }
    },

    '::Registration Details',
    {
      name: 'vessel_registry_port',
      label: 'Port of Registry',
      // options: ports,
      required: false,
      hint: 'Omit if not available',
    },
    {
      name: 'vessel_registry_number',
      label: 'Port Official Number',
      required: false,
      hint: 'Omit if not available',
    },
    {
      name: 'vessel_home_port',
      label: 'Intended Home Port',
      // options: ports,
    },
    {
      name: 'fishing_areas',
      label: 'Main Fishing Areas',
      options: islands,
      multi: true,
      hint: 'Select all that apply'
    },
    {
      name: 'vessel_value',
      is: 'currency',
      label: 'Value of Vessel',
    },
    '::Uploads',
    {
      key: 'image.1',
      type: 'file:all',
      name: 'bill_sale_upload',
      label: 'Vessel Bill Of Sale',
    },
    {
      key: 'image.2',
      type: 'file:all',
      name: 'proof_payment_upload',
      label: 'Proof of Payment',
    },
    {
      key: 'image.3',
      type: 'file:all',
      name: 'vessel_certificate_upload',
      label: 'Vessel Certificate of Title',
    },
    {
      key: 'image.4',
      type: 'file:all',
      name: 'copy_transfer_upload',
      label: 'Copy of Transfer Order',
    },
    {
      key: 'image.5',
      type: 'file:all',
      name: 'registration_notice_upload',
      label: 'Notice of Intended Registration',
      required: false
    },
    {
      key: 'image.6',
      type: 'file:all',
      name: 'exchange_permission_upload',
      label: 'Exchange Control Permission',
      hint: 'Permission from Exchange Control to purchase foreign currency',
    }
  ]

  hidden_fields = () => [
    {
      name: 'pdf_upload',
      type: 'file:pdf',
      label: 'Certificate of Registration',
      key: 'image.0',
    },
  ]

  render = () => <Wizard {...common(this)} />
}
